module.exports = "<p>\n  mobile-app works!\n</p>\n"